module.exports = __webpack_public_path__ + "static/media/google_play.1ac584bf.png";